import React, { useState } from "react";
import { Table, Select, Input } from "antd";
import styles from "./AdminReceipeManagement.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dropdown,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";

import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/archive.svg";

import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";

const AdminReceipeManagement = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Product Name",
      dataIndex: "ProductName",
      key: "Allergen Name",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Product Tag",
      dataIndex: "ProductTag",
      key: "Product Tag",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },

    {
      title: "Allergen Marking",
      dataIndex: "AllergenMarking",
      key: "AllergenMarking",
      render: (text, record) => (
        <div className={styles.AllergenMarking}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() => navigate("/RecipeManagement/CreateRecipe")}
          />

          <EditIcon
            className={styles.itemsButton}
            onClick={() => navigate("/productionManagement/ReciepeBuilder")}
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },
  ];

  const data = [
    {
      No: "1",
      ProductName: "Ciabatta",
      ProductTag: "Cake",
      LinkedRecipes: 1,
      AllergenMarking: 1,
      LastModified: "Aug 01, 2025",
      action: "View",
    },
    {
      No: "2",
      ProductName: "Baguette",
      LinkedRecipes: 2,
      AllergenMarking: 5,
      LastModified: "Aug 01, 2025",

      ProductTag: "Cake",
      action: "Edit",
    },
    {
      No: "  3   ",
      ProductName: "Multigrain bread",
      AllergenMarking: 4,
      LastModified: "Aug 01, 2025",

      ProductTag: "bread",
      LinkedRecipes: 3,

      action: "View",
    },
    {
      No: "4",
      ProductName: "Pita bread",
      LinkedRecipes: 5,
      AllergenMarking: 9,
      LastModified: "Aug 01, 2025",

      ProductTag: "bread",

      action: "View",
    },
    {
      No: "5",
      ProductName: "Sourdough",
      LinkedRecipes: 4,
      AllergenMarking: 3,
      LastModified: "Aug 01, 2025",
      action: "Deactivate",
      ProductTag: "bread",
    },
    {
      No: "6",
      ProductName: "Croissants",
      ProductTag: "Custom",
      LinkedRecipes: 2,
      AllergenMarking: 8,
      LastModified: "Aug 01, 2025",

      action: "Cake",
    },
  ];

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Recipe Management"}
        onSearch={(e) => setSearchTerm(e.target.value)}
        onSubmit={() => navigate("/productionManagement/ReciepeBuilder")}
        submitButtonText={"Create Recipe"}
        // showBackIcon={true}
        showFilterIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />

      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="staffId"
        />
      </div>
      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        onClickCancelButton={() => setIsModal(false)}
        okBtnTitle={"Yes"}
        twoButton
        cancelBtnTitle={"No"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        onBtnPress={() => setIsModal(false)}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </Modal>
    </div>
  );
};

export default AdminReceipeManagement;
